import request from '@/utils/request'

const url = '/home/cabinet/'
const api = {
  onSubmitCabinet (data) {
    return request({
      url: url + 'onSubmitCabinet',
      method: 'post',
      data
    })
  },
  getCabinet (data) {
    return request({
      url: url + 'getCabinet',
      method: 'post',
      data
    })
  },
  lightUp (data) {
    return request({
      url: url + 'lightUp',
      method: 'post',
      data
    })
  },
  bindGoods (data) {
    return request({
      url: url + 'bindGoods',
      method: 'post',
      data
    })
  },
  getLedGoods (data) {
    return request({
      url: url + 'getLedGoods',
      method: 'post',
      data
    })
  },
  editWarehouse (data) {
    return request({
      url: url + 'editWarehouse',
      method: 'post',
      data
    })
  },
  getWarehouse (data) {
    return request({
      url: url + 'getWarehouse',
      method: 'post',
      data
    })
  },
  deleteWarehouse (data) {
    return request({
      url: url + 'deleteWarehouse',
      method: 'post',
      data
    })
  },
  upStoreGoods (data) {
    return request({
      url: url + 'publicsh',
      method: 'post',
      data
    })
  },
  deleteGoods (data) {
    return request({
      url: url + 'deleteGoods',
      method: 'post',
      data
    })
  },
  CancelTheMerger (data) {
    return request({
      url: url + 'CancelTheMerger',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/cabinet.js